// ============================================================================
// FRENCH TRANSLATIONS - CHAPTER 5: L'ÉGLISE PRIMITIVE
// ============================================================================
// Niveaux 53-65 (13 niveaux, 39 questions)

export const chapter5Translations = {
  name: "L'Église Primitive",
  description: "Et vous recevrez une puissance...",
  
  spiritualWisdom: {
    principle: "L'Esprit Saint donne puissance et courage pour témoigner",
    scripture: "Vous recevrez une puissance, le Saint-Esprit survenant sur vous, et vous serez mes témoins (Actes 1:8)",
    application: "L'Église naît dans le feu de l'Esprit et grandit par le témoignage courageux"
  },
  
  levels: {
    53: {
      name: "L'Ascension",
      challenge: "Vous serez mes témoins... jusqu'aux extrémités de la terre...",
      easy: {
        question: "Combien de jours après sa résurrection Jésus monta-t-il au ciel ?",
        options: ["30 jours", "40 jours", "50 jours", "60 jours"],
        hint: "Le nombre biblique de préparation",
        funFact: "☁️ 40 jours d'enseignement intensif avant la mission mondiale!"
      },
      medium: {
        question: "Quelle promesse Jésus fait-il avant de monter au ciel ?",
        options: [
          "Il reviendra bientôt",
          "Il enverra le Saint-Esprit avec puissance",
          "Il construira une église",
          "Il punira les méchants"
        ],
        hint: "Une puissance d'en haut",
        funFact: "⚡ Promesse du Saint-Esprit - transformation des disciples craintifs!"
      },
      hard: {
        question: "Que symbolise l'Ascension dans notre vie spirituelle ?",
        options: [
          "La fin de la présence de Jésus",
          "Jésus règne et intercède pour nous au ciel",
          "Une séparation définitive",
          "Un mythe symbolique"
        ],
        hint: "Il s'agit de sa présence glorifiée et active",
        funFact: "👑 Jésus règne à la droite de Dieu et intercède pour nous!"
      }
    },
    
    54: {
      name: "La Pentecôte",
      challenge: "Ils furent tous remplis du Saint-Esprit et se mirent à parler...",
      easy: {
        question: "Combien de jours après l'Ascension eut lieu la Pentecôte ?",
        options: ["7 jours", "10 jours", "14 jours", "20 jours"],
        hint: "Une dizaine de jours",
        funFact: "🔟 10 jours de prière intense préparent à l'effusion de l'Esprit!"
      },
      medium: {
        question: "Sous quelle forme le Saint-Esprit apparut-il ?",
        options: [
          "Comme un vent violent",
          "Comme des langues de feu",
          "Comme une colombe",
          "Comme une lumière"
        ],
        hint: "Des flammes qui se posent sur chaque disciple",
        funFact: "🔥 Langues de feu : l'Esprit donne courage et don des langues!"
      },
      hard: {
        question: "Que représente la Pentecôte pour l'Église universelle ?",
        options: [
          "Un événement historique isolé",
          "La naissance officielle de l'Église missionnaire",
          "Un miracle de curiosité",
          "Le début des célébrations"
        ],
        hint: "Il s'agit de l'acte de naissance de l'Église",
        funFact: "🎂 Pentecôte = anniversaire de l'Église, début de la mission mondiale!"
      }
    },

    55: {
      name: "Le Premier Sermon de Pierre",
      challenge: "Que ferons-nous, hommes frères ? Repentez-vous...",
      easy: {
        question: "Combien de personnes furent baptisées après le sermon de Pierre ?",
        options: ["1000", "2000", "3000", "5000"],
        hint: "Trois milliers d'âmes",
        funFact: "🌊 3000 baptêmes en un jour - réveil spirituel extraordinaire!"
      },
      medium: {
        question: "De quoi Pierre accusa-t-il la foule ?",
        options: [
          "D'ignorance",
          "D'avoir crucifié Jésus, le Messie",
          "De manque de foi",
          "D'hypocrisie"
        ],
        hint: "Le crime suprême contre le Fils de Dieu",
        funFact: "⚔️ Pierre, qui avait renié Jésus, proclame maintenant sa divinité!"
      },
      hard: {
        question: "Comment la transformation de Pierre illustre-t-elle l'œuvre du Saint-Esprit ?",
        options: [
          "Il devient plus instruit",
          "De lâche et instable, il devient courageux et ferme dans la foi",
          "Il acquiert des pouvoirs",
          "Il change de personnalité"
        ],
        hint: "Il s'agit de la sanctification par l'Esprit",
        funFact: "🗿 Le 'roseau agité' devient 'pierre ferme' - puissance transformatrice!"
      }
    },

    56: {
      name: "La Première Communauté",
      challenge: "Ils persévéraient dans la doctrine des apôtres, la communion fraternelle...",
      easy: {
        question: "Comment les premiers chrétiens partageaient-ils leurs biens ?",
        options: [
          "Chacun gardait le sien",
          "Ils avaient tout en commun",
          "Seuls les riches donnaient",
          "Par obligation légale"
        ],
        hint: "Communauté de biens volontaire",
        funFact: "🤝 Amour fraternel si intense qu'ils partagent spontanément tout!"
      },
      medium: {
        question: "À quoi les premiers chrétiens consacraient-ils leur temps ?",
        options: [
          "Aux affaires seulement",
          "Doctrine, communion, fraction du pain, prières",
          "Au travail uniquement",
          "Aux loisirs"
        ],
        hint: "Quatre piliers de la vie communautaire",
        funFact: "⛪ Doctrine, communion, eucharistie, prière - fondations de l'Église!"
      },
      hard: {
        question: "Pourquoi cette première communauté était-elle si attractive ?",
        options: [
          "Elle était riche",
          "L'amour authentique et la joie rayonnaient de leur unité",
          "Elle promettait des miracles",
          "Elle critiquait les autres"
        ],
        hint: "Il s'agit du témoignage de l'amour vécu",
        funFact: "✨ 'Voyez comme ils s'aiment!' - témoignage qui convainc plus que les mots!"
      }
    },

    57: {
      name: "La Guérison du Boiteux",
      challenge: "De l'argent et de l'or, je n'en ai point; mais ce que j'ai, je te le donne...",
      easy: {
        question: "Depuis combien de temps l'homme était-il boiteux ?",
        options: [
          "Depuis 20 ans",
          "Depuis 30 ans", 
          "Depuis sa naissance",
          "Depuis 10 ans"
        ],
        hint: "Une infirmité de toujours",
        funFact: "🚶 40 ans d'infirmité guéris instantanément au nom de Jésus!"
      },
      medium: {
        question: "Au nom de qui Pierre guérit-il le boiteux ?",
        options: [
          "Au nom de Dieu",
          "Au nom de Jésus-Christ de Nazareth",
          "En son propre nom",
          "Au nom d'Abraham"
        ],
        hint: "Le nom qui est au-dessus de tout nom",
        funFact: "✊ Le nom de Jésus continue d'opérer des miracles par les apôtres!"
      },
      hard: {
        question: "Que symbolise cette guérison pour l'Évangile ?",
        options: [
          "Un simple miracle médical",
          "Le salut total que Jésus apporte : spirituel et physique",
          "Le pouvoir des apôtres",
          "La charité envers les pauvres"
        ],
        hint: "Il s'agit du salut intégral de l'être humain",
        funFact: "🩺 Jésus guérit l'âme et le corps - salut complet de la personne!"
      }
    },

    58: {
      name: "La Persécution Commence",
      challenge: "Il vaut mieux obéir à Dieu qu'aux hommes...",
      easy: {
        question: "Qui arrêta Pierre et Jean après la guérison du boiteux ?",
        options: [
          "Les Romains",
          "Les sadducéens et les prêtres",
          "Le peuple",
          "Pilate"
        ],
        hint: "Les autorités religieuses juives",
        funFact: "⛓️ Première persecution religieuse - l'Évangile dérange l'establishment!"
      },
      medium: {
        question: "Quelle interdiction les autorités donnèrent-elles aux apôtres ?",
        options: [
          "De quitter Jérusalem",
          "De ne plus enseigner au nom de Jésus",
          "De ne plus faire de miracles",
          "De ne plus prier"
        ],
        hint: "Interdiction de prêcher",
        funFact: "🚫 On tente de faire taire la vérité - impossible d'arrêter l'Évangile!"
      },
      hard: {
        question: "Comment les apôtres réagissent-ils face à l'interdiction ?",
        options: [
          "Ils obéissent par peur",
          "Ils affirment devoir obéir à Dieu plutôt qu'aux hommes",
          "Ils négocient",
          "Ils fuient"
        ],
        hint: "Il s'agit d'une fidélité plus haute que les lois humaines",
        funFact: "⚖️ Désobéissance civile pour obéir à Dieu - courage de la conviction!"
      }
    },

    59: {
      name: "Ananias et Saphira",
      challenge: "Ce n'est pas à des hommes que tu as menti, mais à Dieu...",
      easy: {
        question: "Quel mensonge Ananias et Saphira ont-ils dit ?",
        options: [
          "Ils n'avaient rien vendu",
          "Ils donnaient tout le prix de leur vente alors qu'ils en gardaient une partie",
          "Ils étaient pauvres",
          "Ils n'étaient pas mariés"
        ],
        hint: "Mensonge sur le montant donné",
        funFact: "💰 Garder une partie était permis, mentir sur le don ne l'était pas!"
      },
      medium: {
        question: "Que leur arriva-t-il après leur mensonge ?",
        options: [
          "Ils furent pardonnés",
          "Ils moururent subitement",
          "Ils furent exclus",
          "Ils se repentirent"
        ],
        hint: "Châtiment immédiat et sévère",
        funFact: "⚱️ Jugement sévère pour préserver la pureté de l'Église naissante!"
      },
      hard: {
        question: "Pourquoi ce châtiment si sévère au début de l'Église ?",
        options: [
          "Dieu était cruel",
          "Pour établir la sainteté requise dans la communauté",
          "Pour faire peur",
          "Par accident"
        ],
        hint: "Il s'agit de préserver l'intégrité spirituelle",
        funFact: "🔥 Standards élevés au début pour établir la culture de sainteté!"
      }
    },

    60: {
      name: "Les Sept Diacres",
      challenge: "Choisissez parmi vous sept hommes de qui l'on rende témoignage...",
      easy: {
        question: "Combien de diacres furent choisis ?",
        options: ["5", "6", "7", "12"],
        hint: "Le nombre de la perfection",
        funFact: "7️⃣ Sept diacres pour le service - organisation divine de l'Église!"
      },
      medium: {
        question: "Quel était leur rôle principal ?",
        options: [
          "Prêcher l'Évangile",
          "Servir aux tables et aider les veuves",
          "Baptiser les nouveaux convertis",
          "Gérer les finances"
        ],
        hint: "Service social et matériel",
        funFact: "🍽️ Service des tables = première organisation caritative chrétienne!"
      },
      hard: {
        question: "Que révèle cette organisation sur la vision chrétienne du service ?",
        options: [
          "Les tâches matérielles sont inférieures",
          "Service spirituel et matériel sont tous deux sacrés",
          "Il faut séparer le sacré du profane",
          "Seuls les prêtres servent vraiment"
        ],
        hint: "Il s'agit de la sacralité de tout service d'amour",
        funFact: "✨ Servir aux tables avec la même dignité que prêcher - tout service est sacré!"
      }
    },

    61: {
      name: "Étienne, Premier Martyr",
      challenge: "Seigneur, ne leur impute pas ce péché ! Et ayant dit cela, il s'endormit...",
      easy: {
        question: "Quelle était la fonction d'Étienne dans l'Église ?",
        options: ["Apôtre", "Diacre", "Prêtre", "Prophète"],
        hint: "Un des sept choisis pour servir",
        funFact: "✨ Étienne : diacre devenu évangéliste puissant et premier martyr!"
      },
      medium: {
        question: "De quoi Étienne accusa-t-il les dirigeants juifs ?",
        options: [
          "De corruption",
          "D'avoir toujours résisté au Saint-Esprit",
          "D'hypocrisie",
          "De cupidité"
        ],
        hint: "Résistance historique à Dieu",
        funFact: "📜 Étienne fait un résumé de l'histoire : rébellion constante contre Dieu!"
      },
      hard: {
        question: "Comment Étienne mourut-il et que révèle son attitude ?",
        options: [
          "Dans la colère contre ses bourreaux",
          "En pardonnant comme Jésus sur la croix",
          "Dans le désespoir",
          "En maudissant ses ennemis"
        ],
        hint: "Il s'agit de l'imitation parfaite du Christ",
        funFact: "💝 Pardon des bourreaux : Étienne reproduit parfaitement l'attitude de Jésus!"
      }
    },

    62: {
      name: "Philippe et l'Eunuque Éthiopien",
      challenge: "Comment pourrais-je comprendre si quelqu'un ne me guide ?",
      easy: {
        question: "Que lisait l'eunuque dans son chariot ?",
        options: [
          "Les Psaumes",
          "Ésaïe le prophète",
          "La Genèse",
          "Les Proverbes"
        ],
        hint: "Le prophète de la Passion du Messie",
        funFact: "📖 Ésaïe 53 - prophétie parfaite de Jésus lue par un chercheur sincère!"
      },
      medium: {
        question: "Comment Philippe expliqua-t-il le passage d'Ésaïe ?",
        options: [
          "Il parla d'histoire ancienne",
          "Il annonça Jésus à partir de ce texte",
          "Il donna une leçon de théologie",
          "Il critiqua les interprétations"
        ],
        hint: "L'Écriture mène naturellement au Christ",
        funFact: "✝️ Toute l'Écriture converge vers Jésus - clé de compréhension!"
      },
      hard: {
        question: "Que symbolise la conversion de l'eunuque éthiopien ?",
        options: [
          "Une conversion isolée",
          "L'universalité de l'Évangile pour toutes les races et conditions",
          "La supériorité de certains peuples",
          "Un cas particulier"
        ],
        hint: "Il s'agit de l'ouverture aux nations",
        funFact: "🌍 Éthiopien, eunuque, ministre : l'Évangile brise toutes les barrières!"
      }
    },

    63: {
      name: "La Conversion de Saul de Tarse",
      challenge: "Saul, Saul, pourquoi me persécutes-tu ?",
      easy: {
        question: "Que faisait Saul avant sa conversion ?",
        options: [
          "Il prêchait l'Évangile",
          "Il persécutait les chrétiens",
          "Il était neutre",
          "Il étudiait seulement"
        ],
        hint: "Ennemi acharné des disciples",
        funFact: "⚔️ Saul respirait menace et meurtre contre les disciples de Jésus!"
      },
      medium: {
        question: "Sur quel chemin Jésus apparut-il à Saul ?",
        options: [
          "Le chemin de Jérusalem",
          "Le chemin de Damas",
          "Le chemin de Gaza",
          "Le chemin d'Antioche"
        ],
        hint: "Une ville de Syrie",
        funFact: "🛤️ Chemin de Damas = lieu de transformation le plus célèbre de l'histoire!"
      },
      hard: {
        question: "Comment cette conversion illustre-t-elle la grâce divine ?",
        options: [
          "Dieu convertit seulement les bons",
          "La grâce peut transformer le pire ennemi en plus grand apôtre",
          "La conversion était méritée",
          "Saul était déjà proche de Dieu"
        ],
        hint: "Il s'agit de la puissance transformatrice de la grâce",
        funFact: "⚡ Du plus grand persécuteur au plus grand missionnaire - miracle de grâce!"
      }
    },

    64: {
      name: "Pierre et Corneille",
      challenge: "En vérité, je reconnais que Dieu ne fait point acception de personnes...",
      easy: {
        question: "Quelle était la profession de Corneille ?",
        options: [
          "Marchand",
          "Centurion romain",
          "Prêtre",
          "Scribe"
        ],
        hint: "Officier de l'armée romaine",
        funFact: "🎖️ Premier païen officiellement converti - ouverture aux non-Juifs!"
      },
      medium: {
        question: "Quelle vision Pierre eut-il avant de rencontrer Corneille ?",
        options: [
          "Un ange lui parlant",
          "Une nappe avec des animaux purs et impurs",
          "Jésus lui apparaissant",
          "Un temple détruit"
        ],
        hint: "Vision sur la pureté et l'impureté",
        funFact: "🕊️ Nappe avec animaux : Dieu abolit les distinctions alimentaires et raciales!"
      },
      hard: {
        question: "Quel principe révolutionnaire cette conversion établit-elle ?",
        options: [
          "Les Romains sont supérieurs",
          "Dieu ne fait acception de personne - salut universel",
          "Il faut abandonner les traditions",
          "La circoncision est inutile"
        ],
        hint: "Il s'agit de l'universalité du salut",
        funFact: "🌍 Révolution spirituelle : l'Évangile est pour tous les peuples sans exception!"
      }
    },

    65: {
      name: "L'Église d'Antioche",
      challenge: "Ce fut à Antioche que les disciples furent appelés chrétiens pour la première fois...",
      easy: {
        question: "Comment appela-t-on les disciples pour la première fois à Antioche ?",
        options: ["Disciples", "Chrétiens", "Fidèles", "Saints"],
        hint: "Le nom que nous portons encore aujourd'hui",
        funFact: "✝️ 'Chrétiens' = 'petits Christs' - nom d'honneur donné par les païens!"
      },
      medium: {
        question: "Qui vint enseigner à Antioche avec Barnabas ?",
        options: [
          "Pierre",
          "Paul (Saul)",
          "Jacques",
          "Jean"
        ],
        hint: "L'ancien persécuteur devenu apôtre",
        funFact: "👥 Barnabas cherche Paul à Tarse - début du ministère paulinien!"
      },
      hard: {
        question: "Pourquoi Antioche devint-elle si importante dans l'histoire chrétienne ?",
        options: [
          "Elle était riche",
          "Premier centre missionnaire vers les païens",
          "Elle était bien située",
          "Elle avait de bons dirigeants"
        ],
        hint: "Il s'agit de l'expansion missionnaire",
        funFact: "🚢 Antioche : port de lancement de toutes les missions de Paul vers l'Europe!"
      }
    }
  }
};

export default chapter5Translations;
